import { render, staticRenderFns } from "./UpgradeProModal.vue?vue&type=template&id=3949bb74&"
import script from "./UpgradeProModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeProModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports